import React from 'react';
import { Sheet, SheetContent, SheetTitle, SheetDescription } from '../ui/sheet';
import { NavLink } from 'react-router-dom';
import Collapsible from 'react-collapsible';

const Sidebar = ({ show, handleClose }) => {

   return (
      <>
         <Sheet open={show} onOpenChange={(open) => { if (!open) handleClose(); }}>
            <SheetContent
               side="right"
               className="side__bar tw-w-[300px] tw-max-w-[85vw] tw-bg-[#FFF] tw-text-white tw-overflow-y-auto tw-p-[30px] tw-border-0"
            >
               <SheetTitle className="tw-sr-only">Mobile navigation</SheetTitle>
               <SheetDescription className="tw-sr-only">Site navigation links</SheetDescription>
               <div className="side__logo tw-mb-6">
                  <NavLink to="/">
                     <img src="assets/img/logo/Harsoft_Logo_Color_svg.svg" alt="logo" />
                  </NavLink>
               </div>
               <div>
                  <nav aria-label="Mobile navigation">
                     <div className="tw-p-0">
                        <div className="sidebar__content">
                           <div className='side_navBar'>
                              <div className='about iconAdd'>
                                 <li><NavLink to="/ourStory">Our Story</NavLink></li>
                              </div>

                              <Collapsible trigger={<NavLink to="/software-product-development">Offerings</NavLink>} triggerTagName="div"
                                 triggerOpenedClassName="icon_close" triggerClassName="iconAdd" open={false}>
                                 <ul className="sidebar_sub_menu submenu text-white">
                                    <li><NavLink to="/software-product-development">Software & Product Development</NavLink></li>
                                    <li><NavLink to="/python-backend-development">Python & Backend Development</NavLink></li>
                                    <li><NavLink to="/ai-automation">AI & Intelligent Automation</NavLink></li>
                                    <li><NavLink to="/database-data-solutions">Database & Data Solutions</NavLink></li>
                                    <li><NavLink to="/UIUX">UI/UX & Product Design</NavLink></li>
                                    <li><NavLink to="/digital-marketing-seo">Digital Marketing & SEO</NavLink></li>
                                    <li><NavLink to="/CMSSolutions">CMS Solutions</NavLink></li>
                                    <li><NavLink to="/SoftwareTesting">Software Testing</NavLink></li>
                                    <li><NavLink to="/ITSupportManaged">IT Support & Managed</NavLink></li>
                                 </ul>
                              </Collapsible>

                              <Collapsible trigger={<NavLink to="/industries/fintech">Industries</NavLink>} triggerTagName="div"
                                 triggerOpenedClassName="icon_close" triggerClassName="iconAdd" open={false}>
                                 <ul className="sidebar_sub_menu submenu text-white">
                                    <li><NavLink to="/industries/fintech">FinTech</NavLink></li>
                                    <li><NavLink to="/industries/food-catering">Food & Catering</NavLink></li>
                                    <li><NavLink to="/industries/agriculture">Agriculture</NavLink></li>
                                    <li><NavLink to="/industries/education">Education</NavLink></li>
                                    <li><NavLink to="/industries/healthcare">Healthcare</NavLink></li>
                                    <li><NavLink to="/industries/real-estate">Real Estate</NavLink></li>
                                    <li><NavLink to="/industries/retail-ecommerce">Retail & E-commerce</NavLink></li>
                                 </ul>
                              </Collapsible>

                              <Collapsible trigger={<NavLink to="/blogs">Insights</NavLink>} triggerTagName="div"
                                 triggerOpenedClassName="icon_close" triggerClassName="iconAdd" open={false}>
                                 <ul className="sidebar_sub_menu submenu text-white text-capitalize">
                                    <li><NavLink to="/blogs">Blog</NavLink></li>
                                    <li><NavLink to="/" end>Case Studies</NavLink></li>
                                 </ul>
                              </Collapsible>
                              <div className='about iconAdd border-0'>
                                 <NavLink to="/contact">Get in touch</NavLink>
                              </div>

                           </div>
                        </div>
                     </div>
                  </nav>
               </div>
            </SheetContent>
         </Sheet>
      </>
   );
};

export default Sidebar;
